<div id="sidebar" class="d-flex flex-column flex-shrink-0 bg-light">
	<ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
		<li class="nav-item">
			<a [routerLink]="['/home']"
				 class="nav-link align-middle py-3 border-bottom "
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 aria-current="page"
				 ngbTooltip="Home"
				 placement="right">
         <em i-bs name="house-fill" width="24" height="24" class="icon-navibar"></em>
			</a>
		</li>
		<li *ngIf="perfilNormativo || perfilTecnico">
			<a [routerLink]="['/processos']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Processos"
				 placement="right">
         <em i-bs name="nut-fill" width="20" height="20"></em>
			</a>
		</li>
		<li *ngIf="perfilAdmin || perfilNormativo || perfilTecnico">
			<a [routerLink]="['/empresas']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Empresas"
				 placement="right">
         <em i-bs name="bank2" width="20" height="20"></em>
			</a>
		</li>
		<li *ngIf="perfilAdmin || perfilNormativo || perfilTecnico">
			<a [routerLink]="['/grupos']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Grupos"
				 placement="right">
         <em i-bs name="people-fill" width="20" height="20"></em>
			</a>
		</li>
		<li *ngIf="perfilAdmin || perfilNormativo || perfilTecnico">
			<a [routerLink]="['/usuarios']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Usuários"
				 placement="right">
				 <em i-bs name="person-fill" width="20" height="20"></em>
			</a>
		</li>
		<li *ngIf="perfilNormativo || perfilTecnico">
			<a [routerLink]="['/mensagens']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Mensagens"
				 placement="right">
         <em i-bs name="envelope-fill" width="20" height="20"></em>
			</a>
		</li>
    <li *ngIf="perfilNormativo || perfilTecnico">
			<a [routerLink]="['/calendario']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Envio de Notificação"
				 placement="right">
         <em i-bs name="calendar-day-fill" width="20" height="20"></em>
			</a>
		</li>
    <li *ngIf=" perfilCalculoRetroativo || perfilTecnico">
			<a [routerLink]="['/upload/interno']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Envio Arquivos Interno"
				 placement="right">
         <em i-bs name="file-earmark-arrow-up" width="20" height="20"></em>
			</a>
		</li>
    <li *ngIf="perfilPatrocInterna || perfilTecnico" >
			<a [routerLink]="['/upload']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Enviar/Receber Arquivos"
				 placement="right">
         <em i-bs name="file-earmark-arrow-up-fill" width="20" height="20"></em>
			</a>
		</li>
    <li *ngIf="perfilPatrocInterna || perfilTecnico" >
			<a [routerLink]="['/arquivosenviados']"
				 class="nav-link align-middle py-3 border-bottom"
				 [routerLinkActive]="['active']"
				 [routerLinkActiveOptions]="{ exact: true }"
				 ngbTooltip="Arquivos Enviados"
				 placement="right">
         <em i-bs name="file-earmark-text-fill" width="20" height="20"></em>
			</a>
		</li>
	</ul>
</div>